import camelcaseKeys from 'camelcase-keys'
import ClickOutside from 'vue-click-outside'
import { Component } from 'vue-property-decorator'

import AssignToMember from '@src/pages/assign-to-member/assign-to-member'
import Member from '@src/data/member'

@Component({
  directives: {
    ClickOutside
  }
})
export class SearchMembers extends AssignToMember {

  search (value) {
    this.searchedText = value
    this.selectedMember = null
    this.showResults = true
    this.assignToMember()
  }

  selectMember (member) {
    this.searchedText = member.fullName
    this.selectedMember = member
    this.assignToMember()
  }

  assignToMember () {
    this.callback(this.selectedMember)
  }

  onClickOutside () {
    this.showResults = false
  }

  protected loadMembers () {
    return this.membersApiClient.get<any>()
      .then(response => {
        this.availableMembers = response.members.filter(member => member.mobile).map(attrs => new Member(camelcaseKeys(attrs)))
      })
      .catch(error => console.error('failed to retrieve members', error))
  }
}
